import React from 'react';

export type LexicalErrorBoundaryProps = {
  children: React.ReactNode;
  onError: (error: Error) => void;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

/**
 * Error boundary component for Lexical editor that:
 * - Reports errors to Mixpanel
 * - Calls optional onError callback
 * - Renders null when an error occurs
 */
export class ErrorBoundary extends React.Component<
  LexicalErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: LexicalErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // Call optional onError callback
    if (this.props.onError) {
      this.props.onError(error);
    }

    // Log to console for development
    console.error('Lexical Editor Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Render nothing when there's an error
      return null;
    }

    return this.props.children;
  }
}
